<template>
  <div>
    <van-swipe :autoplay="3000" class="my-swipe" indicator-color="white">
      <van-swipe-item>
        <img alt="" src="@/assets/images/top-banner.png"/>
      </van-swipe-item>
    </van-swipe>
    <div class="banner">
      <img src="~@/assets/images/bg_reserve.png"/>
    </div>
    <div class="count-bar">
      查询已入库 <span>{{ this.total }}</span> 家
    </div>
    <div class="search-box">
      <van-field v-model="keyword" left-icon="search" placeholder="请输入搜索关键词" @keydown.enter="init(true)"/>
    </div>
    <div class="data-list">
      <van-empty v-show="list.length < 1 && !load" description="请将企业加入储备库后查看哦" image="search"
                 style="color: goldenrod;background: linear-gradient(296deg, #2E2A29 0%, #404040 100%);border-radius: 3px"/>

      <!--主分类-->
      <div class="item">
        <ul class="data-ul">
          <van-list
              v-model="load"
              :finished="finished"
              finished-text="已经到底了~"
              @load="init"
          >
            <li v-for="item in list" :key="item.id">
              <div class="company-text">
                <router-link :to="{name:'Hall',query:{id:item.company_id}}">
                  <span class="tag-short_name">{{ item.ShortName }}</span>
                  {{ item.CompanyName }}
                </router-link>
              </div>

              <div class="box-rank-data van-clearfix">
                <div>
                  <router-link :to="{name:'Hall',query:{id:item.company_id}}">
                    <van-image :src="item.logo" class="company-logo" fit="contain" lazy-load
                    >
                      <template v-slot:error>无企业LOGO</template>
                    </van-image>
                  </router-link>
                </div>
                <div>

                  <div class="tag-val-box van-clearfix">
                    <div>
                      <router-link :to="{name:'Hall',query:{id:item.company_id}}">
                        <div class="val-tips rank-brand">{{ item.CreditCode ? item.CreditCode : '-' }}</div>
                        <div class="val-tips-sm">统一信用代码</div>
                      </router-link>
                    </div>
                  </div>
                  <div class="btn-box">
                    <collection :company_id="item.CompanyId" style="margin-bottom: 10px"></collection>
                    <connect :company="item"></connect>
                  </div>
                </div>
              </div>
            </li>
          </van-list>
        </ul>
      </div>
    </div>
  </div>
</template>


<style scoped>


.data-list {
  padding: 10px;
  color: #ffffff;
  margin-bottom: 60px;
}

.data-list .max-title {
  color: rgba(232, 191, 162, 1);
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 14px;
  margin: 15px 0 8px 0;
}

.data-list li {
  border: 1px solid #C2965E;
  background: linear-gradient(296deg, #2E2A29 0%, #404040 100%);
  min-height: 120px;
  margin-bottom: 30px;
  position: relative;
  padding: 15px 10px;
  box-sizing: border-box;
  border-radius: 3px;
}

.box-rank-data {
  margin-top: 15px;
}

.box-rank-data > div {
  float: left;
}

.box-rank-data > div:nth-child(1) {
  width: 100px;
}

.box-rank-data > div:nth-child(2) {
  width: calc(100% - 105px);
  margin-left: 5px;
  position: relative;
}

.box-rank-data > div:nth-child(2)::before {
  content: " ";
  background: url("~@/assets/images/bg_rank.png") no-repeat;
  background-size: contain;
  height: 120px;
  width: 75px;
  position: absolute;
  top: 10px;
  right: -10px;
}


.box-rank-data .company-logo {
  width: 100px;
  height: 55px;
  display: block;
  background: white;
  object-fit: contain;
  border-radius: 3px;
}


.company-text, .company-text a {
  color: #E8B279;
  display: block;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(232, 178, 121, .2);
}
.company-text a{
  border: none;
}

.tag-box .tag-brand-text {
  min-width: 4.2rem;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}

.tag-box .tag-brand {
  background: rgba(252, 214, 172, 1);
  padding: 2px;
}

.tag-box .tag-brand-num {
  background: rgba(109, 81, 216, 1);
  color: rgba(208, 196, 255, 1);
  padding: 2px;
}

.btn-box {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.tag-val-box > div {
  float: left;
  margin-right: 5px;
  background: rgba(232, 191, 162, .1);
  border-radius: 3px;
  text-align: center;
  box-sizing: border-box;
  padding: 5px;
  font-size: 12px;
}

.tag-val-box > div:last-child {
  margin-right: 0;
}

.tag-val-box > div:nth-child(1) {
  width: calc(100% - 5px);
  margin-left: 5px;
}


.val-tips {
  font-size: 14px;
  font-weight: bolder;
  color: goldenrod;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.val-tips.rank-brand {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}


.val-tips-sm {
  color: rgba(232, 191, 162, .6);
  margin-top: 5px;
  height: 16px;
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;

}

body .company-logo /deep/ .van-image__error {
  text-align: center;
  font-size: 12px;
  border-radius: 3px;
}

.banner {
  padding: 10px;
}

.banner img{
  border-radius: 3px;
}

.search-box {
  padding: 0 10px;
}

.search-box /deep/ .van-field {
  color: goldenrod;
  background: linear-gradient(
      296deg, #2E2A29 0%, #404040 100%);
  padding: 10px;
  border-radius: 6px;
}

.search-box /deep/ input {
  background: transparent;
  color: #E8B279;
  font-weight: bold;
}

.tag-short_name {
  background: #F56C6C;
  color: #fde2e2;
  margin-right: 5px;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  padding: 0 5px;
  display: inline-block;
  border-radius: 3px;
  min-width: 4rem;
  text-align: center;
}

.count-bar {
  padding: 0 10px;
  color: #FFFFFF;
  font-size: 12px;
  margin-bottom: 10px;
  text-align: right;
}

.count-bar > span {
  color: #F62A3A;
}
</style>
<script>
import Collection from "../components/Collection";
import Connect from "../components/Connect";

export default {
  name: "Index",
  metaInfo: {
    title: '我的优质资源储备库 @优采云大数据服务平台',
    htmlAttrs: {
      lang: 'zh-CN',
      keyword:'优采云，大数据，云服务，报告',
      amp: true
    }
  },
  components: {Connect, Collection},
  data() {
    return {
      keyword: '',
      list: [],
      total: 0,
      load: false,
      finished: false,
      page: 1
    }
  },
  mounted() {

  },
  methods: {
    init(reset_page = false) {
      //某些情况下重置
      if (reset_page) {
        this.page = 1
        this.list = []
        this.finished =false
      }
      this.load = true
      this.$axios.post(this.$apiconfg.collection, {
        keyword: this.keyword,
        page: this.page
      }).then(({data}) => {
        if (data.code === 1) {
          //翻页
          this.page += 1
          //没有下一页了
          if (data.data.hasMore) {
            this.finished = false
          } else {
            this.finished = true
          }
          for (let i = 0; i < data.data.list.length; i++) {
            this.list.push(data.data.list[i])
          }

          this.total = data.data.total
        }
        this.load = false
      }).catch(() => {
        this.load = false
        this.finished = true
      })
    }
  }
}
</script>